import React from "react";
import SlotsFake from "./slots-fake";

const AppointmentFake = ({ withoutContainer }) => {
  return (
    <>
      <section className={withoutContainer ? "" : "container"}>
        <div className="appointment-fake">
          <div className="appointment-fake--box-1">
            <div className="skeleton appointment-fake--box-1--title" />
            <div className="skeleton appointment-fake--box-1--date" />
          </div>
          <div className="appointment-fake--calendar">
            <div className="skeleton appointment-fake--calendar--title" />
            <div className="skeleton appointment-fake--calendar--box" />
          </div>
          <div className="appointment-fake--slots">
            <SlotsFake />
          </div>
          <div className="skeleton appointment-fake--button" />
        </div>
      </section>
      <style jsx>{`
        .appointment-fake {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: start;
          &--box-1 {
            width: 100%;
            display: flex;
            flex-direction: column;
            border-radius: 8px;
            border: 1px solid #dddddd;
            padding: 1rem;
            gap: 1rem;
            &--title {
              height: 22px;
              width: 25%;
            }
            &--date {
              height: 20px;
              width: 100%;
            }
          }
          &--calendar {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            margin-top: 1rem;
            &--title {
              width: 50%;
              height: 16px;
            }
            &--box {
              border-radius: 8px;
              height: 205px;
              width: 100%;
            }
          }
          &--slots {
            margin: 1rem 0;
          }
          &--button {
            width: 100%;
            height: 48px;
          }
        }
        @media (min-width: 768px) {
          .appointment-fake {
            width: 23.75rem;
            &--button {
              width: 66%;
            }
          }
        }
      `}</style>
    </>
  );
};

export default AppointmentFake;
